module.exports = __webpack_public_path__ + "static/media/vmsg.ea1e8f3d.wasm";


//////////////////
// WEBPACK FOOTER
// ./node_modules/mp3-mediarecorder/dist/vmsg.wasm
// module id = 561
// module chunks = 0